<nav id="main-nav" class="navbar navbar-expand-lg fixed-top navbar-light mb-3">
  <div class="d-inline-block sidenav-toggle-btn">
    <button mat-icon-button (click)="onToggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <a class="navbar-brand mr-1" (click)="onClosePortfolio()"
    ><img src="../../../../assets/images/logo-white.svg" alt="Cimalti"
  /></a>

  <mat-nav-list class="nav-list mr-0 justify-content-end pt-0 ms-auto">
    <div class="nav-item user-nav-button">
      <button mat-icon-button class="nav-link" [matMenuTriggerFor]="usermenu">
        @if (user && user.id) {
          <span
            class="nav-user-photo"
            [style.backgroundImage]="'url(' + user.getPhoto() + ')'"
          ></span>
        }
      </button>
      <mat-menu #usermenu="matMenu" [overlapTrigger]="false">
        <!--<div mat-menu-item class="pt-2">
        <mat-slide-toggle (toggleChange)="onToggleChange($event)" (click)="$event.stopPropagation();" color="primary"><mat-icon color="primary">dark_mode</mat-icon></mat-slide-toggle>
      </div>-->
        <button mat-menu-item type="button" [routerLink]="['/app/settings']">
          My profile
        </button>
        <mat-divider class="w-100"></mat-divider>
        <button mat-menu-item type="button" (click)="onLogout()">
          Sign out
        </button>
      </mat-menu>
    </div>
  </mat-nav-list>
</nav>
